// stores/locale.ts
import { defineStore } from 'pinia'

export const useLocaleStore = defineStore('locale', {
    state: () => ({
        language: 'fr' // langue par défaut
    }),
    actions: {
        setLanguage(lang) {
            this.language = lang
        }
    },
    persist: {
        key:'locale',
        secure: process.env.NODE_ENV === 'production',
        paths: ['language'] // facultatif ici, mais utile si tu as d'autres props
    }
})
